import ProductFragment from '../product/ProductFragment';
import PetProfileFragment from '../profile/PetProfileFragment';
export default `
  fragment PlanFragment on Plan {
    id
    weight
    meal
    percentage
    profile {
      ...PetProfileFragment         
    }
    startDate
    endDate
    status
    products {
      ...ProductFragment
    }
  }
  ${PetProfileFragment}
  ${ProductFragment}
`;
